import loaderClient from "api/reduxLoaderApi";
import { toast } from "react-toastify";
import {
  setSupportCurrentTicket,
  setSupportTicketComments,
  setSupportTicketList,
  setSupportTotalItems,
} from "./supportSlice";

const normalizeList = (res) => {
  const list = Array.isArray(res.message)
    ? res.message
    : Array.isArray(res.message?.tickets)
    ? res.message.tickets
    : Array.isArray(res.message?.data)
    ? res.message.data
    : [];

  const totalItems =
    res.result_number ||
    res.message?.result_number ||
    res.message?.total ||
    list.length;

  return { list, totalItems };
};

export const getSupportTickets = (params) => async (dispatch) => {
  const query = params ? `?${params}` : "";
  const client = loaderClient("get")(`/v2/backoffice/tickets${query}`);
  const res = await client({})({});

  if (res.error) return toast.error(res.message);

  const { list, totalItems } = normalizeList(res);
  dispatch(setSupportTotalItems(totalItems));
  return dispatch(setSupportTicketList(list));
};

export const getSupportTicketById = (ticketId) => async (dispatch) => {
  const client = loaderClient("get")(`/v2/backoffice/tickets/${ticketId}`);
  const res = await client({})({});

  if (res.error) return toast.error(res.message);
  return dispatch(setSupportCurrentTicket(res.message));
};

export const getSupportTicketComments = (ticketId) => async (dispatch) => {
  const client = loaderClient("get")(
    `/v2/backoffice/tickets/${ticketId}/comments`
  );
  const res = await client({})({});

  if (res.error) return toast.error(res.message);
  return dispatch(setSupportTicketComments(res.message || []));
};

export const createSupportTicketComment = (
  ticketId,
  body,
  params,
  callback = false
) => async (dispatch) => {
  const client = loaderClient("post")(
    `/v2/backoffice/tickets/${ticketId}/comments`
  );
  const res = await client(body)({});

  if (res.error) {
    toast.error(res.message);
    return callback && callback(res.error);
  }

  toast.success("Ticket updated successfully.");
  dispatch(setSupportTicketComments(res.message || []));
  dispatch(getSupportTicketById(ticketId));
  dispatch(getSupportTickets(params));
  return callback && callback(null);
};
